import { api_bd, api_bd_nr } from './Api'

export const logoff = () => ({glpi_data: {}, sgi_data: {}})

export const login = async (_user, _pass) => {
	return new Promise((resolve,reject)=>{
		// console.log(_user, _pass)
		const usernamePasswordBuffer = Buffer.from(_user + ':' + _pass);
		const base64data = usernamePasswordBuffer.toString('base64');
	
		api_bd_nr.get('/users/login/',{
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Basic ${base64data}`
				'ldata': `Basic ${base64data}`
			}
		}).then(({data})=>{
			resolve(data)
		}).catch(e =>{
			reject(e)
		})
	})
}

export const twoFaVerify = async (_user, _pass, _2facode) => {
	return new Promise((resolve,reject)=>{
		// console.log(_user, _pass)
		const usernamePasswordBuffer = Buffer.from(_user + ':' + _pass);
		const base64data = usernamePasswordBuffer.toString('base64');
	
		api_bd_nr.get(`/users/login?opt=verify&code=${encodeURI(_2facode)}`,{
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Basic ${base64data}`
				'ldata': `Basic ${base64data}`
			}
		}).then(({data})=>{
			resolve(data)
		}).catch(e =>{
			reject(e)
		})
	})
}

export default login;